import { createWebRegistration } from '@reflex/plugin-api/create-web-registration';
import { CodexIcon } from './icons/CodexIcon';

export default createWebRegistration({
  icons: {
    CodexIcon,
  },
});
